export default "__VITE_ASSET__XLfDdrYB__"